{
  "clientPortal": "Client Portal",
  "lightMode": "Light mode",
  "darkMode": "Dark mode",
  "logout": "Logout",
  "dashboard": "Dashboard",
  "inventory": "Inventory",
  "grn": "GRNs",
  "dispatchOrders": "Dispatch Orders",
  "invoices": "Invoices",
  "dateRangeFilter": {
    "label": "Date Range",
    "from": "From",
    "to": "To",
    "clear": "Clear"
  },
  "dashboardPage": {
    "title": "Dashboard",
    "subtitle": "Everything about your account with this warehouse — inventory, GRNs, dispatch orders, and invoices — in one place.",
    "stockValue": "Stock Value",
    "pendingGrns": "Pending GRNs",
    "pendingDispatchOrders": "Pending Dispatch Orders",
    "unpaidInvoices": "Unpaid Invoices",
    "unpaidInvoiceAmount": "Unpaid Amount"
  },
  "overviewPanel": {
    "activityTitle": "Monthly Activity",
    "activitySubtitle": "GRNs received vs. dispatch orders raised over the last 6 months.",
    "invoiceStatusTitle": "Invoice Status"
  },
  "inventoryPanel": {
    "totalMaterials": "Distinct Materials",
    "totalOnHand": "Total On Hand",
    "totalAllocated": "Total Allocated",
    "totalAvailable": "Total Available",
    "topMaterialsTitle": "Top Materials by Quantity On Hand"
  },
  "grnPanel": {
    "totalGrns": "Total GRNs",
    "acceptedQty": "Accepted Qty",
    "rejectedQty": "Rejected Qty",
    "trendTitle": "Accepted vs. Rejected Quantity — Last 6 Months"
  },
  "dispatchPanel": {
    "totalOrders": "Total Dispatch Orders",
    "issuedQty": "Issued Qty",
    "pendingQty": "Pending Qty",
    "trendTitle": "Dispatch Activity — Last 15 Days",
    "trendSubtitle": "Orders raised and quantity issued, day by day.",
    "ordersSeries": "Orders",
    "statusTitle": "Status Breakdown"
  },
  "invoicesPanel": {
    "totalInvoiced": "Total Invoiced",
    "paidAmount": "Paid",
    "unpaidAmount": "Unpaid",
    "trendTitle": "Billed Amount — Last 6 Months",
    "billedAmount": "Billed Amount",
    "statusTitle": "Status Breakdown"
  },
  "inventoryPage": {
    "title": "Inventory",
    "subtitle": "Your current stock on hand at this warehouse.",
    "table": {
      "materialCode": "Code",
      "materialName": "Material",
      "warehouseName": "Warehouse",
      "quantityOnHand": "On Hand",
      "quantityAllocated": "Allocated",
      "quantityAvailable": "Available"
    }
  },
  "grnPage": {
    "title": "Goods Receipt Notes",
    "subtitle": "Inbound receipts of your goods at this warehouse.",
    "table": {
      "grnNumber": "GRN No.",
      "grnDate": "Date",
      "supplierName": "Supplier",
      "warehouseName": "Warehouse",
      "status": "Status",
      "materialName": "Material",
      "acceptedQty": "Accepted Qty",
      "rejectedQty": "Rejected Qty"
    }
  },
  "dispatchOrdersPage": {
    "title": "Dispatch Orders",
    "subtitle": "Outbound orders shipping your goods from this warehouse.",
    "table": {
      "orderNumber": "Order No.",
      "orderDate": "Date",
      "customerName": "Customer",
      "status": "Status",
      "materialName": "Material",
      "issuedQty": "Issued Qty"
    }
  },
  "invoicesPage": {
    "title": "Invoices",
    "subtitle": "GST tax invoices issued to you for storage, handling, and value-added services.",
    "table": {
      "invoiceNumber": "Invoice No.",
      "invoiceDate": "Date",
      "billingPeriod": "Billing Period",
      "totalAmount": "Total Amount",
      "status": "Status",
      "downloadPdf": "Download PDF"
    }
  }
}
